import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface ICompanyDetail {
    id?: string,
    prefix?: string,
    shopId?: string,
    shopCode?: string,
    shopName?: string,
    branch?: string,
    ver?: string,
    enable?: string,
    orgCode?: string,
    orgName?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: number | boolean,
    sourceApp?: string,
    categoryName?:string,
    typeCode?:string,
    typeName?:string,
    suffixNum?: number,
    settingType? : string,
    isYear?: number,
    isMonth?: number,
    isDate?: number,
    style? : string,
    note? : string,
    orderNum?: number,
    traceId?: string,
    deleteFlag?: number,
    createTime? : string,
    updateTime? : string,
    createUser? : string,
    updateUser? : string,
    [key: string]: any
}
//新增
export interface ICompanyInsert {
    "prefix"?:string,   // "ad reprehenderit magna in",
    "suffixNum"?:number,   // 22,
    "settingType"?:string,   // "CALCULATE",
    "isYear"?:number,   // 55,
    "isMonth"?:number,   // 59,
    "isDate"?:number,   // 20180911,
    "note"?:string,   // "veniam sint laborum tempor",
    "style"?:string,   // "incididunt"
}

//编辑
export interface ICompanyUpdate extends ICompanyInsert {
    id?: string,
}
//搜索条件
export interface ICompanySearchFields {
    startTime?:string
    endTime?:string
    [key:string]:any
}

export interface ICompanySearch
    extends ICompanySearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch
    extends ICompanySearchFields, ISearchPage {
}



class CompanyService {
    async page(searchVo: ICompanySearch, config: object = {}) {
        const apiUrl = "/threeInspection/institution/list";
        return await httpRequest.post<any>(apiUrl, searchVo, config);
    }     
    async insert(searchVo: ICompanySearchFields) {
        const apiUrl = "/threeInspection/institution/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }    
    async edit(searchVo: ICompanySearchFields) {
        const apiUrl = "/threeInspection/institution/update";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async onDelete(searchVo: ICompanySearchFields) {
        const apiUrl = "/threeInspection/institution/delete";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }  
    async one(searchVo: ICompanySearchFields) {
        const apiUrl = "/threeInspection/ciOrder/page";
        return await httpRequest.post<IPage<ICompanyDetail>>(apiUrl, searchVo);
    }    
    async orderLogs(searchVo: ICompanySearchFields) {
        const apiUrl = "/threeInspection/ciOrder/progress_log/list";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async getCompanyImg(updateVo: ICompanyUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getImageClassifyList(updateVo: ICompanyUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
}

export const companyService = new CompanyService();